<template>
    <el-drawer :title="isEdit ? '编辑' : '添加'" :visible.sync="drawer" :modal="true" :wrapperClosable="false" size="600px"
        @close="closeDrawer" :modal-append-to-body="false" :direction="direction">

        <!-- title -->
        <div class="drawer_form">

            <el-form :model="form" status-icon :rules="rules" ref="form" label-width="120px" class="demo-ruleForm">

                <div class="form-body">
                    <overlay-scrollbars style="width: 100%;height: 100%;" class="el-fade-in">
                        <el-form-item label="名称" prop="name">
                            <el-input type="text" v-model="form.name" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="指标层级" prop="level">
                            <el-select v-model="form.level" class="w-full" placeholder="请选择">
                                <el-option label="二级指标" :value="2"></el-option>
                                <el-option label="三级指标" :value="3"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="最大分数" prop="maxScore">
                            <el-input type="text" v-model="form.maxScore" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="内置指标" prop="isSys" v-if="form.level === 3" size="mini">
                            <el-radio-group v-model="form.isSys">
                                <el-radio-button :label="true">是</el-radio-button>
                                <el-radio-button :label="false">否</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="指标类型" prop="code" v-if="form.level===3&&form.isSys">
                            <el-select v-model="form.code" class="w-full" placeholder="请选择">
                                <el-option label="音量时间变化分析" key="teacher_volume" value="teacher_volume"></el-option>
                                <el-option label="语速时间变化分析" key="teacher_speech_rate" value="teacher_speech_rate"></el-option>
                                <el-option label="教师语音综合分析" key="teacher_voice" value="teacher_voice"></el-option>
                                <el-option label="对话编码数据S-T分析" key="s-t_coding" value="s-t_coding"></el-option>
                                <el-option label="教师活动情况分析" key="teacher_activity" value="teacher_activity"></el-option>
                                <el-option label="教师行为表情情况分析" key="teacher_behavior_emotion" value="teacher_behavior_emotion"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="指标类型" prop="" v-if="form.level !== 3">
                            <el-select v-model="form.reviewType" class="w-full" placeholder="请选择">
                                <el-option v-for="item in $store.state.dict.review_lists" :key="item.value"
                                    :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="智能体" prop="agentCode" v-if="form.level === 3">
                            <el-select v-model="form.agent" class="w-full" placeholder="请选择智能体">
                                <el-option v-for="item in agentList" :key="item.agentCode" :label="item.agentName"
                                    :value="item.agentCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="专家权重值" prop="" v-if="form.level !== 3 && [4, 5].includes(form.reviewType)">
                            <el-input type="text" v-model="form.expertWeight" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="机器权重值" prop="" v-if="form.level !== 3 && [4, 5].includes(form.reviewType)">
                            <el-input type="text" v-model="form.machineWeight" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="描述" prop="description">
                            <el-input type="textarea" rows="4" v-model="form.description" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="评分细则" prop="scoreDesc">
                            <el-input type="textarea" rows="6" v-model="form.scoreDesc" autocomplete="off"></el-input>

                        </el-form-item>
                    </overlay-scrollbars>
                </div>

                <div class="form-foot d-flex a-center j-center">
                    <el-button @click="onSubmit" class="common-button">{{ isEdit ? '提交' : '添加' }}</el-button>
                </div>
            </el-form>
        </div>

    </el-drawer>

</template>

<script>
import { rule_create, get_rule } from '@/request/api/module.js'
import { listAgent } from '@/request/api/common.js'
export default {
    data() {
        return {
            drawer: true, //表单
            direction: 'rtl',//抽屉方向
            loading: false,
            isEdit: false, // 判断是编辑还是新增
            agentList: [], // 智能体列表
            form: {
                id: '', // 编辑时需要
                name: '',//指标名称
                maxScore: '',//最大值
                expertWeight: '',//专家权重
                machineWeight: '',//机器全重
                reviewType: '',//评级类型
                description: '',//描述
                level: 2, //指标层级
                agentCode: '', //智能体
                scoreDesc: '', //评分细则
                isSys: false, //是否内置指标
                code:'',//内置指标编码
            },

            rules: {
                name: [
                    { required: true, message: '名称必填', trigger: 'blur' },
                ],
                level: [
                    { required: true, message: '请选择指标层级', trigger: 'change' },
                ],
                maxScore: [
                    { required: true, message: '请输入最大分数', trigger: 'blur' },
                ],
            }
        }
    },
    created() {
        // 判断是否为编辑模式
        this.isEdit = !!this.$route.query.id
        this.form.id = this.$route.query.id || ''
        this.init()
    },
    watch: {
        'form.level'(newVal) {
            // 当选择二级指标时，清空智能体选择
            if (newVal === 2) {
                // this.form.agent = ''
                this.form.agentCode = ''
            }
            // 当选择三级指标时，清空指标类型和相关权重值
            else if (newVal === 3) {
                this.form.reviewType = ''
                this.form.expertWeight = ''
                this.form.machineWeight = ''
            }
        },
        'form.isSys'(newVal){
            if(newVal===false){
                this.form.code=''
            }
        }
    },
    methods: {
        init() {

            // 如果是编辑模式，加载数据
            if (this.isEdit) {
                get_rule(this.form.id).then(res => {
                    Object.keys(this.form).forEach(item => {
                        if (res.data) {
                            this.form[item] = res.data[item]
                        }
                    })
                    // 确保智能体选择器能正确显示选中状态
                    if (res.data && res.data.agentCode) {
                        this.form.agent = res.data.agentCode
                    }
                })
            }

            // 加载智能体列表
            listAgent().then(res => {
                this.agentList = res.data || []
            })
        },
        onSubmit() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.req()
                } else {
                    return false;
                }
            });
        },

        //req - 根据是否为编辑模式调用不同的接口
        req() {
            // 创建表单数据的副本，确保正确传递agentCode
            const formData = { ...this.form }
            // 当选择了智能体时，将agent字段的值赋给agentCode
            if (formData.agent && !formData.agentCode) {
                formData.agentCode = formData.agent
            }
            // 删除不需要的agent字段，避免API接口混淆
            delete formData.agent

            if(formData.isSys===false){
                delete formData.code
            }


            rule_create(formData).then(res => {
                if (res.code != 0) return this.$notify({ title: '失败', message: res.msg, type: 'error' });
                this.$notify({ title: '成功', message: "SUCCESS", type: 'success' });
                this.$router.go(-1)
            })
        },


        //重置表单
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },

        //关闭抽屉
        closeDrawer() {
            this.$router.go(-1)
        }
    }

}
</script>


<style lang="less" scoped></style>
